import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import download from 'downloadjs';

export const COMPETITION_CATEGORY_RESULT_REQUEST = 'FETCH_COMPETITION_CATEGORY_RESULT_REQUEST';
export const COMPETITION_CATEGORY_RESULT_FAILURE = 'FETCH_COMPETITION_CATEGORY_RESULT_FAILURE';
export const COMPETITION_CATEGORY_RESULT_SUCCESS = 'FETCH_COMPETITION_CATEGORY_RESULT_SUCCESS';

export const fetchCompetitionCategoryResultReport = (competition, category) => {
    return function(dispatch) {
        dispatch(fetchRequest());

        return axios(apiRequestOptions(apiPath.REPORTS.COMPETITION_RESULT, null, {
            params: {competition, category},
            isBlob: true,
        }))
            .then(transformHttpResponse)
            .then(response => {
                const content = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'] || '';
                const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
                const filename = filenameMatch ? filenameMatch[1] : 'report.pdf';
                download(response.data, filename, content);
                dispatch(fetchSuccess());
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

/**
 * A CATEGORY'S PARTICIPANTS, PRINTED (2 Nov 2026) — country at an international
 * competition, oblast, club, weight, розряд, кю / дан. A PDF to save.
 */
export const downloadCategoryParticipantsReport = (competition, category) => dispatch => axios(apiRequestOptions(
    apiPath.REPORTS.CATEGORY_PARTICIPANTS, null, { params: { competition, category }, isBlob: true },
))
    .then(transformHttpResponse)
    .then(response => {
        const contentDisposition = response.headers['content-disposition'] || '';
        const filenameMatch = contentDisposition.match(/filename="?([^";\s]+)"?/);
        download(response.data, filenameMatch ? filenameMatch[1] : 'participants.pdf', response.headers['content-type']);
    })
    .catch(error => transformHttpResponse(error.response))
    .catch(error => dispatch(errorRequestHandler(error)));

const fetchRequest = () => ({type: COMPETITION_CATEGORY_RESULT_REQUEST});

const fetchFailure = error => ({type: COMPETITION_CATEGORY_RESULT_FAILURE, error,});

const fetchSuccess = () => ({type: COMPETITION_CATEGORY_RESULT_SUCCESS});
